import { render, staticRenderFns } from "./queryBookMoveHistory.vue?vue&type=template&id=beaf27d4&"
import script from "./queryBookMoveHistory.vue?vue&type=script&lang=js&"
export * from "./queryBookMoveHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports